"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialog = require("@alicd/next/lib/dialog");

var _dialog2 = _interopRequireDefault(_dialog);

var _PopupConfirm = require("./PopupConfirm");

var _PopupConfirm2 = _interopRequireDefault(_PopupConfirm);

var _localeProvider = require("@alicd/next/lib/locale-provider");

var _localeProvider2 = _interopRequireDefault(_localeProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import locale from "./locale";

var PopupConfirmWithLocale = (0, _localeProvider2.default)(_PopupConfirm2.default);
PopupConfirmWithLocale.LOCALE = _dialog2.default.LOCALE;

exports.default = PopupConfirmWithLocale;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-popup-confirm@0.0.2@@alicd/crui-popup-confirm/lib/index.js
// module id = 655
// module chunks = 0